import { useCallback } from 'react';

import { loadWhiteboardStore } from '../../components/whiteboard/loadAppWhiteboardStore';
import { isWhiteboardUserEditingAtom } from '../../components/whiteboard/state';
import { equivalentSnapshot, mergeSnapshot } from '../../components/whiteboard/utils';
import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { Statsig } from '../../statsig/StatsigProvider';
import { whiteboardEventualConsistencyGate } from '../../statsig/gates';
import { DataChannelWhiteboardSnapshotMessage } from '../../video-sdk';

export function useLoadWhiteboardStoreSnapshotCallback() {
  const getIsWhiteboardUserEditing = useAtomCallbackMemoized((get) => get(isWhiteboardUserEditingAtom), []);

  return useCallback(
    async (receivedMessage: DataChannelWhiteboardSnapshotMessage) => {
      const currentStore = await loadWhiteboardStore();

      if (Statsig.checkGate(whiteboardEventualConsistencyGate)) {
        const receivedSnapshot = receivedMessage.snapshot;
        const isEditingWhiteboard = getIsWhiteboardUserEditing();
        if (isEditingWhiteboard || equivalentSnapshot(currentStore, receivedSnapshot)) {
          return;
        }
        await mergeSnapshot(currentStore, receivedSnapshot);
      } else {
        currentStore.loadStoreSnapshot(receivedMessage.snapshot);
      }
    },
    [getIsWhiteboardUserEditing],
  );
}
